export default __webpack_public_path__ + "static/media/icon6.92a51eb1.svg";